import { countryList } from '../constants/countries';

const VISITOR_COUNTRY_STORAGE_KEY = 'prairi_visitor_country';

/** Best-effort country for anonymous visitors — cached for the browser session. */
export async function detectVisitorCountry(): Promise<string | undefined> {
  try {
    const cached = sessionStorage.getItem(VISITOR_COUNTRY_STORAGE_KEY)?.trim();
    if (cached && countryList.includes(cached)) return cached;

    const response = await fetch('https://ipapi.co/json/');
    if (!response.ok) return undefined;

    const data = (await response.json()) as { country_name?: string };
    const country = data.country_name?.trim();
    if (!country || !countryList.includes(country)) return undefined;

    sessionStorage.setItem(VISITOR_COUNTRY_STORAGE_KEY, country);
    return country;
  } catch {
    return undefined;
  }
}
